import { styled } from "../../../styles";

export const ContentContainer = styled("div", {
  width: "100%",
  padding: "62px 0 0 280px",
  height: "100%",
  overflowY: "auto",
  backgroundColor: "$gray-20",
  touchAction: "auto",
  transition: "padding 250ms ease",

  "@media screen and (max-width: 1100px)": {
    padding: "62px 0 0 0",
  },

  variants: {
    sidebarState: {
      expanded: {
        padding: "62px 0 0 280px",
        "@media screen and (max-width: 1100px)": {
          padding: "62px 0 0 0",
        },
      },
      collapsed: {
        padding: "62px 0 0 56px",
        "@media screen and (max-width: 1100px)": {
          padding: "62px 0 0 0",
        },
      },
      hidden: {
        padding: "62px 0 0 0",
      },
    },
  },
});

export const NavContentContainer = styled("div", {
  display: "flex",
  flexGrow: 1,

  "@media screen and (max-width: 1100px)": {
    width: "100%",
    justifyContent: "flex-end",
  },
});

export const TopPanelItemsContainerDesktop = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginLeft: "24px",

  "@media screen and (max-width: 1100px)": {
    display: "none",
  },
});

export const UnauthorizedContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  gap: "16px",
  padding: "24px",
  textAlign: "center",
});

export const UnauthorizedTitle = styled("h1", {
  fontFamily: "$nunito",
  fontSize: "$heading-text-h3",
  color: "$black",
  margin: 0,
});

export const UnauthorizedText = styled("p", {
  fontFamily: "$openSans",
  fontSize: "$text-xl",
  color: "$gray-90",
  margin: 0,
  maxWidth: "400px",
});
